<template>
  <!--<transition mode="out-in"-->
              <!--enter-active-class="animated zoomInUp"-->
              <!--leave-active-class="animated zoomOutDown">-->
    <div style="width: 100%">

      <!--主图-->
      <div class="mainImg">
        <img src="../assets/communityDetail.jpg" alt="动态新闻">
      </div>

      <!--标题-->
      <div class="mainTitle">
        <Row style="text-align: center; height: 100%">
          <Col span="8" style="text-align: center; height: 100%">
            <p class="btn" @click="showNews(1)">公司新闻</p></Col>
          <Col span="8" style="text-align: center; height: 100%">
            <p class="btn" @click="showNews(2)">行业动态</p></Col>
          <Col span="8" style="text-align: center; height: 100%">
            <p class="btn" @click="showNews(3)">媒体报导</p></Col>
        </Row>
      </div>

      <!--新闻动态：详情-->
      <div class="news" v-for="(value,index) in newsList">
        <div class="newsItem">
            <a href="#" @click="toNews(index)" style="display: inline-block; width: 100px;height: 100px; margin-left: 5%;">
              <img :src="value.titleImgUrl" alt="一张图片" style="width: 100px;height: 100px;">
            </a>
          <div class="newsInfo">
            <br>
            <a href="#" class="textTitle" @click="toNews(index)">{{value.mainTitle}}</a>
            <br>
            <p class="textInfo">{{value.summary}}</p>
            <br>
          </div>
        </div>
      </div>

      <!--翻页-->
      <!--<div style="width: 100%">
        <Page :total="dataCount"
              :page-size="pageSize"
              show-total
              class="paging"
              @on-change="changePage">
        </Page>
      </div>-->

      <!--页脚-->
      <div class="footer">
        <ul style="display: flex;align-items: center;flex-direction: column;list-style: none;justify-content: center; height: 100%">
          <li class="info">Copyright © 2017-2020 All rights reserved 版权所有 © 无障碍科技有限公司</li>
          <li class="info">备案号：鄂ICP备18005954号</li>
        </ul>
      </div>

    </div>
  <!--</transition>-->
</template>

<script>
  // import 'animate.css/animate.css'
  export default {
    name: "news",
    data(){
      return{
        dataCount:10,
        pageSize:20,
        newsList:[]//新闻列表
      }
    },
    methods:{
      showNews(num){
          this.newsList = [];
          this.$http.get('/zm/WMWebsite/queryNewsInfos').then(res=>{
              let temp = res.data.content;
              temp.map( (item) => {
                  if (item.newsCategory === num){
                      this.newsList.push(item);
                  }
              })
          })
      },/*发送请求，获取新闻列表*/
      changePage(){

      },/*翻页*/
      toNews(index){
        this.$router.push({
          path:'/newsDetail',
          query:{
            newsItem:this.newsList[index]
          }
        });
      },/*转到新闻详情页*/
      getNewsState(){
          this.newsList = [];
          this.$http.get('/zm/WMWebsite/queryNewsInfos').then(res=>{
          let temp = res.data.content;
          temp.map( (item) => {
              if (item.newsCategory === 1){
                  this.newsList.push(item);
              }
          })
        })
      }//获取新闻列表
    },
    activated(){
      this.getNewsState();
    }
  }
</script>

<style scoped>
  .mainImg img {
    width: 100%;
    height: 600px;
  }  /*主图*/
  .mainTitle{
    width: 100%;
    height: 100px;
    background-color: rgba(57, 207, 200, 1);
    margin-top: -1%;
    margin-bottom: 3%;
  }/*标题背景*/

  .mainTitle .btn{
    height: 100%;
    cursor: pointer;
    color: rgba(255, 255, 255, 1);
    font-size: 1.1rem;
    margin-top: 40px;
  }/*标题文字*/
  .mainTitle .btn:hover{
    color: gray;
  }/*移动到标题文字时*/
  .newsItem{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 80%;
    margin: 0 0 1% 10%;
    background-color:rgba(69,193,192, 0.1);
  }
  .textTitle{
    font-size: 1.2rem;
    color: rgba(13, 117, 116, 1);
    margin-left: 5%;
  }
  .textTitle:hover{
    font-weight: bolder;
  }
  .textInfo{
    font-size: 1rem;
    color:rgba(13, 117, 116, 0.6);
    text-indent: 2rem;
    width: 90%;
    margin-left: 5%;
  }
  .newsInfo{
    display: flex;
    flex-direction: column;
    width: 90%;
    justify-content: space-between;
    overflow: hidden;
  }
  .paging{
    display: block;
    margin:1% 0;
    text-align: center;
  }/*翻页*/
  .footer{
    background-color: rgba(57, 207, 204, 1);
    text-align: center;
    width: 100%;
    height: 130px;
  }/*页脚*/
  .footer .info{
    color:#fff;
    font-size:0.8rem;
  }/*页脚：里面的内容*/

  /*手机竖屏*/
  @media only screen
  and (min-width: 320px)
  and (max-width: 767px)
  and (orientation: portrait){
    .mainImg img{
      height: 200px;
      margin-top:1%;
    }
  }

  /*手机横屏*/
  @media only screen
  and (min-width: 320px)
  and (max-width: 767px)
  and (orientation: landscape){
    .mainImg img{
      height: 300px;
      margin-top:1%;
    }
  }

  /*平板竖屏*/
  @media only screen
  and (min-width: 768px)
  and (max-width: 1024px)
  and (orientation: portrait){
    .mainImg img{
      height: 400px;
      margin-top:2%;
    }
  }

  /*平板横屏*/
  @media only screen
  and (min-width: 768px)
  and (max-width: 1024px)
  and (orientation: landscape){
    .mainImg img{
      height: 400px;
      margin-top:2%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/News.vue